<div class="logo">
  <img src="/assets/logo_small.svg" alt="">
</div>
